(() => {
  class CustomPersonalization extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.blockId = this.dataset.blockId;

      this.form = this.formId ? document.getElementById(this.formId) : null;
      if (!this.form) {
        this.form =
          this.closest('form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add"]');
      }
      if (!this.form) return;

      // Accordion elements
      this.detailsEl = this.querySelector(".custom-personalization__details");
      this.summaryEl = this.querySelector(".custom-personalization__summary");

      // Toggles
      this.toggles = Array.from(
        this.querySelectorAll(".custom-personalization__toggle")
      );

      this.toggles.forEach((toggle) => {
        toggle.addEventListener("change", () => {
          this.onToggleChange(toggle);
          this.updateAccordionLock();
        });

        // init
        this.onToggleChange(toggle, true);
      });

      // Lock logic: prevent closing when any option selected
      if (this.summaryEl) {
        this.summaryEl.addEventListener("click", (e) => {
          if (this.isLocked() && this.detailsEl?.open) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      if (this.detailsEl) {
        this.detailsEl.addEventListener("toggle", () => {
          if (this.isLocked() && !this.detailsEl.open) {
            this.detailsEl.open = true;
          }
        });
      }

      // Set initial lock state
      this.updateAccordionLock();

      // Intercept submit once
      if (!this.form.__customPersonalizationBound) {
        this.form.addEventListener("submit", (e) => this.onSubmit(e), true);
        this.form.__customPersonalizationBound = true;
      }
    }

    isLocked() {
      return this.toggles?.some((t) => t.checked);
    }

    updateAccordionLock() {
      if (!this.detailsEl) return;

      const locked = this.isLocked();

      if (this.summaryEl) {
        this.summaryEl.setAttribute("aria-disabled", locked ? "true" : "false");
      }

      if (locked && !this.detailsEl.open) {
        this.detailsEl.open = true;
      }
    }

    onToggleChange(toggle, isInit = false) {
      const optionEl = toggle.closest(".custom-personalization__option");
      const field = optionEl
        ? optionEl.querySelector(".custom-personalization__field")
        : null;

      if (!field) return;

      if (toggle.checked) {
        field.hidden = false;
      } else {
        field.hidden = true;

        const input = field.querySelector(".custom-personalization__input");
        const err = field.querySelector(".custom-personalization__error");
        if (input) input.value = "";
        if (err) {
          err.hidden = true;
          err.textContent = "";
        }
      }

      if (!isInit) {
        const err = field.querySelector(".custom-personalization__error");
        if (err) {
          err.hidden = true;
          err.textContent = "";
        }
      }
    }

    /**
     * Теперь: свойства из текстового поля вешаем НА UPSELL item (не на основной).
     * Возвращаем:
     *  - upsellItems: [{id, quantity, properties?}, ...]
     */
    buildUpsellItemsOrShowErrors() {
      const upsellItems = [];
      let firstInvalid = null;

      this.toggles.forEach((toggle) => {
        if (!toggle.checked) return;

        const upsellVariantId = toggle.dataset.upsellVariantId;
        const textEnabled = toggle.dataset.textEnabled === "true";
        const textRequired = toggle.dataset.textRequired === "true";
        const propertyLabel = (toggle.dataset.propertyLabel || "").trim();

        const optionEl = toggle.closest(".custom-personalization__option");
        const field = optionEl
          ? optionEl.querySelector(".custom-personalization__field")
          : null;
        const input = field
          ? field.querySelector(".custom-personalization__input")
          : null;
        const err = field
          ? field.querySelector(".custom-personalization__error")
          : null;

        let value = "";
        if (textEnabled && input) value = (input.value || "").trim();

        // Validation
        if (textEnabled && textRequired && !value) {
          if (err) {
            err.textContent = "Please fill in this field.";
            err.hidden = false;
          }
          if (!firstInvalid && input) firstInvalid = input;
          return;
        } else if (err) {
          err.hidden = true;
          err.textContent = "";
        }

        // Build upsell item
        if (upsellVariantId) {
          const item = {
            id: Number(upsellVariantId),
            quantity: 1,
          };

          // Put properties on upsell item (not on main)
          if (textEnabled && propertyLabel && value) {
            item.properties = {
              [propertyLabel]: value,
            };
          }

          upsellItems.push(item);
        }
      });

      if (firstInvalid) {
        firstInvalid.focus();
        return null;
      }

      return upsellItems;
    }

    async onSubmit(e) {
      if (!this.form || e.target !== this.form) return;

      const upsellItems = this.buildUpsellItemsOrShowErrors();
      if (!upsellItems) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      // Если ничего не выбрано — не перехватываем, пусть тема добавит обычный товар
      if (!upsellItems.length) return;

      // Перехватываем: добавим основной товар + upsells с properties
      e.preventDefault();
      e.stopImmediatePropagation();

      const submitButtons = Array.from(this.form.elements).filter(
        (el) => el && el.tagName === "BUTTON" && el.type === "submit"
      );
      submitButtons.forEach((btn) => btn.setAttribute("aria-busy", "true"));

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:start", { bubbles: true })
      );

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      try {
        const formData = new FormData(this.form);
        const mainId = Number(formData.get("id"));
        const mainQty = Number(formData.get("quantity") || 1);

        const items = [];

        // Main item WITHOUT properties (важно!)
        items.push({ id: mainId, quantity: mainQty });

        // Upsells (properties live here)
        upsellItems.forEach((u) => items.push(u));

        const root = window.Shopify?.routes?.root || "/";
        const sectionsUrl = mainId
          ? `${root}variants/${mainId}`
          : window.location.pathname;

        const res = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items,
            sections: sectionsToBundle.join(","),
            sections_url: sectionsUrl,
          }),
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(
            data?.description || data?.message || "Add to cart failed"
          );
        }

        const cartRes = await fetch(`${root}cart.js`, {
          headers: { Accept: "application/json" },
        });
        const cart = await cartRes.json();
        cart.sections = data.sections;

        this.form.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: data.items ? data.items : [data],
              cart,
              onSuccessDo:
                this.form.querySelector('[name="on_success"]')?.value,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              onSuccessDo:
                this.form.querySelector('[name="on_success"]')?.value,
              cart,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent("custom:personalization:added", {
            detail: { cart },
          })
        );
      } catch (err) {
        console.error("[CustomPersonalization]", err);

        const firstErr = this.querySelector(".custom-personalization__error");
        if (firstErr) {
          firstErr.textContent = err.message || "Something went wrong.";
          firstErr.hidden = false;
        } else {
          alert(err.message || "Something went wrong.");
        }

        this.form.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: { error: err?.message || "Cart error" },
          })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      } finally {
        submitButtons.forEach((btn) => btn.removeAttribute("aria-busy"));
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true })
        );
      }
    }
  }

  if (!customElements.get("custom-personalization")) {
    customElements.define("custom-personalization", CustomPersonalization);
  }
})();
